import * as React from 'react';

import { SectionBlock } from '../SectionBlock';
import { Tabs, TTab } from '@cian/ui-kit';

import * as styles from './Advantages.css';

type AdvantagesProps = {
  title: string;
  description: string;
  activeTabView: JSX.Element;
  activeTabIndex: number;
  onTabClick: (tabIndex: number) => void;
  tabItems: TTab[];
};

export const Advantages: React.FC<AdvantagesProps> = ({
  title,
  description,
  activeTabView,
  tabItems,
  activeTabIndex,
  onTabClick,
}) => {
  return (
    <SectionBlock sectionTabTitle={title} title={title} description={description} id="advantages">
      <div className={styles['tabs-wrapper']}>
        <Tabs
          dataTestId="advantages-tabs"
          activeTabIndex={activeTabIndex}
          items={tabItems}
          animated
          onTabClick={onTabClick}
        />
      </div>
      {activeTabView}
    </SectionBlock>
  );
};
